/**
 * The timed-out component is shown after a database query has timed out
 */
angular.module('app').component('timedOut', {
    bindings: {
        onRetry: '&'
    },
    controller: function () {
        this.$onInit = function () {
            // Nothing to do here
        };
    },
    template: `
<div class="timed-out">
    <i class="fa fa-exclamation-triangle fa-2x fa-fw margin-bottom fail text-danger pull-right"></i>
    <strong>Data Request Timed Out</strong>',
    <ol>
        <li>Your request timed out as it did not receive a reply from the server in a timely manner.</li>
        <li>If this continues to happen you should contact your system administrator.</li>
        <li>Click below to retry the data request.</li>
    </ol>
    <div class="text-center space-top">
        <button class="btn btn-lg btn-default" ng-click="$ctrl.onRetry()">RETRY</button>
    </div>
</div>
`
});
